import { APP_ROUTES } from "@/utils";
import { FiMenu, PhRUser } from "@payping/icons";
import { Button, Flex } from "@payping/web-components";
import { useState } from "react";
import { Link } from "react-router";
import { PPFullColorLogoFa } from "@/core/utils";
import MobileMenu from "./MobileMenu";

const Header = () => {
  const [openMenu, setOpenMenu] = useState(false);
  return (
    <>
      <Flex
        justify="space-between"
        className="tw:h-full tw:border-0 tw:border-b tw:border-solid tw:border-color-border tw:max-xs:border-b-0 tw:max-xs:shadow-[0_2px_5px_rgba(0,0,0,0.1)]"
      >
        <Flex className="tw:w-full tw:p-5!" align="center">
          <img className="tw:max-lg:hidden" src={PPFullColorLogoFa} width={60} height={24} />
          <div className="tw:hidden tw:max-lg:block">
            <Button
              onClick={() => {
                setOpenMenu(true);
              }}
              type="text"
              className="tw:p-0!"
            >
              <FiMenu width={20} />
            </Button>
          </div>
        </Flex>
        <Flex className="tw:px-6!" align="center" gap={18}>
          <Link className="tw:text-color-text" to={APP_ROUTES.home.profile.root.url}>
            <PhRUser width={20} />
          </Link>
        </Flex>
      </Flex>
      {openMenu ? <MobileMenu open={openMenu} onClose={() => setOpenMenu(false)} /> : null}
    </>
  );
};

export default Header;
